export const PKG_NAME = "@hpcc-js/codemirror";
export const PKG_VERSION = "3.10.2";
export const BUILD_VERSION = "3.36.0";
